// ── 서브경로 프리픽스 — 같은 도메인 하위(/rmt 등)에 배포할 때 사용 ─────────
// VUE_APP_BASE_PREFIX="/rmt" 이면 API/소켓/업로드/정적을 /rmt 하위로 네임스페이싱.
// 루트(서브도메인) 배포면 빈 문자열('') → 아무 프리픽스 없음.
export const BASE_PREFIX = process.env.VUE_APP_BASE_PREFIX || "";

// 루트기준 절대경로(/api, /uploads 등)에 BASE_PREFIX 를 붙인다. (이미 http(s):// 면 그대로)
export function withBase(path) {
  if (!path || /^https?:\/\//i.test(path)) return path;
  if (!BASE_PREFIX) return path;
  return path.startsWith("/") ? BASE_PREFIX + path : path;
}

// 외부 Auth(SSO) 서버 base URL
// 배포 환경별로 .env 의 VUE_APP_AUTH_URL 로 지정. 없으면 BASE_PREFIX 기준 상대경로(/[rmt/]api/auth).
export const AUTH_URL =
  process.env.VUE_APP_AUTH_URL || withBase("/api/auth") || "https://dev.mdtdexter.com:8723/api/auth";

// ── Janus(미디어) / STUN / TURN — 배포 환경별 env 로 지정 ──────────────
// 하드코딩 제거: 환경별로 VUE_APP_JANUS_URL / VUE_APP_STUN_URL / VUE_APP_TURN_* 만 바꿔 빌드.
// TURN 은 VUE_APP_TURN_URL 이 있을 때만 iceServers 에 추가(자격증명 동반).
export const JANUS_SERVER_URL =
  process.env.VUE_APP_JANUS_URL || "wss://remote.mdtdexter.com:8989";

export const JANUS_ICE_SERVERS = (() => {
  const stun = process.env.VUE_APP_STUN_URL || "stun:remote.mdtdexter.com:3478";
  const servers = [{ urls: stun }];
  if (process.env.VUE_APP_TURN_URL) {
    servers.push({
      urls: process.env.VUE_APP_TURN_URL,
      username: process.env.VUE_APP_TURN_USER || "",
      credential: process.env.VUE_APP_TURN_CRED || "",
    });
  }
  return servers;
})();

// ── Google Maps API 키 — 배포 환경별 env(VUE_APP_GOOGLE_MAPS_API_KEY)로 지정 ──
// ⚠️ 클라이언트(브라우저) 키라 빌드 산출물에 노출됨(불가피). 보안은 GCP 콘솔의
//    HTTP 리퍼러/도메인 제한으로 처리할 것. 소스 하드코딩만 제거.
export const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || "";
